// @ts-strict-ignore
import React from "react";

import { DateRange } from "../models/filters";

export type Preset = "last7d" | "last30d" | "last90d" | "last120d";

const isoDateUTC = (d: Date) => d.toISOString().substring(0, 10);

const rangeForPreset = (preset: Preset): DateRange => {
  const now = new Date();
  // End at today (UTC date portion)
  const to = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    0, 0, 0, 0,
  ));

  const days = preset === "last7d" ? 6 : preset === "last30d" ? 29 : preset === "last90d" ? 89 : 119;
  const from = new Date(to);

  from.setUTCDate(to.getUTCDate() - days);

  return {
    from: isoDateUTC(from),
    to: isoDateUTC(to),
  };
};

export const useAnalyticsFilters = () => {
  const [preset, setPresetState] = React.useState<Preset>("last90d");
  const [dateRange, setDateRange] = React.useState<DateRange>(rangeForPreset("last90d"));

  const setPreset = React.useCallback((p: Preset) => {
    setPresetState(p);
    setDateRange(rangeForPreset(p));
  }, []);

  return {
    preset,
    dateRange,
    setPreset,
  } as const;
};
